module.exports = __webpack_public_path__ + "img/git_icon.e17d9d39.svg";